import { FilterName, mttDefaultState } from '@swf/poker';

import type { PokerMultiTableTournamentsState } from './types';

export const INITIAL_ACTIVE_FILTERS = {
  channels: [],
  games: [],
  seats: [],
  speeds: [],
  state: [],
  structures: [],
  total: { minimum: 0, maximum: 0 },
  upcomingOnly: true
};

export const INITIAL_ACTIVE_UI_FILTERS = {
  [FilterName.BuyIn]: [],
  [FilterName.Games]: [],
  [FilterName.Speed]: [],
  [FilterName.TableSize]: []
};

export const defaultState: PokerMultiTableTournamentsState = {
  ...mttDefaultState,
  activeFilters: { upcomingOnly: true },
  activeUiFilters: INITIAL_ACTIVE_UI_FILTERS
};
